import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../common/types';
import { readOnlyArtistMessages } from './readOnlyArtistMessages';
import styles from './DemoArtistTag.module.scss';

/** The quiet "Read-only" tag after the name of an artist above the artist limit of the plan. */
const ReadOnlyArtistTagComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <span className={styles.tag} data-testid="read-only-artist-tag">
      {intl.formatMessage(readOnlyArtistMessages.tag)}
    </span>
  );
};

export const ReadOnlyArtistTag = TypedMemo(ReadOnlyArtistTagComponent);
